export enum EsignType {
	SsnRequired = 0,
	SsnNotRequired = 1,
	SsnNotRequiredCanAdd = 2,
	SsnNotRequiredForVendor = 3
}

export enum CustomerRole {
	NotSet = 0,
	Customer = 1,
	CoSigner = 2,
	Guarantor = 3,
	Supplier = 5,
	Custom = 6,
	LimitCustomer = 7,
	Vendor = 8,
	ResidualValueGuarantor = 9,
	Spouse = 10,
	Cohabitant = 11,
	HouseOwner = 12
}
